import { Injectable } from '@angular/core';
import magnitudesData from '../data/magnitudes_unidades.json';

interface MagnitudConfig {
    unidad_base: string;
    unidades: { [key: string]: number };
}

interface MagnitudesData {
    [key: string]: MagnitudConfig;
}

@Injectable({
    providedIn: 'root'
})
export class UnitsService {
    private magnitudes: { nombre: string; config: MagnitudConfig }[] = [];
    private conversionRates: Map<string, number> = new Map();

    constructor() {
        this.loadUnits();
    }

    private loadUnits(): void {
        try {
            const data = magnitudesData as MagnitudesData;

            // Recorrer las magnitudes y cargarlas con nombre y contenido
            Object.entries(data).forEach(([nombre, config]) => {
                this.magnitudes.push({
                    nombre,
                    config
                });

                // Cargar cada unidad en el Map con su tasa de conversión
                Object.entries(config.unidades).forEach(([unidad, tasa]) => {
                    this.conversionRates.set(unidad, tasa);
                });
            });

            console.log('Magnitudes cargadas:', this.magnitudes);
            console.log('Tasas de conversión cargadas:', this.conversionRates);
        } catch (error) {
            console.error('Error al cargar las unidades:', error);
        }
    }

    getMagnitudes(): { nombre: string; config: MagnitudConfig }[] {
        return this.magnitudes;
    }

    getConversionRate(unit: string): number | undefined {
        return this.conversionRates.get(unit);
    }

    getMagnitudByName(nombre: string): { nombre: string; config: MagnitudConfig } | undefined {
        return this.magnitudes.find(m => m.nombre === nombre);
    }

    getUnitsByMagnitude(magnitudeName: string): string[] {
        const units: string[] = [];
        const magnitude = this.getMagnitudByName(magnitudeName.trim());
        if (magnitude) {
            const config = magnitude.config;
            for (const unit in config.unidades) {
                if (config.unidades.hasOwnProperty(unit)) {
                    units.push(unit);
                }
            }
        }
        return units;
    }

    getMagnitudeNames(): string[]{
        return this.magnitudes.map(m => m.nombre);
    }
}
